import PropTypes from "prop-types";
import TripCard from "components/shared/stays/TripCard";
import styles from "components/stay/RecommendedSmall.module.scss";

export default function RecommendedSmall({ trips }) {
  return (
    <div className={styles.component}>
      <div className={styles.list}>
        {trips.slice(0, 3).map((trip) => (
          <TripCard
            key={trip.id}
            name={trip.name}
            slug={trip.slug}
            country={trip.country}
            lowestPrice={trip.lowest_price}
            pricingType={trip.pricing_type}
            typeDescription={trip.trip_type_description}
            isFeatured={trip.is_featured}
            // reviewScores={trip.review_scores}
            imageUrl={trip.image_url}
            orientation="horizontal"
            tripID={trip.id}
          />
        ))}
      </div>
    </div>
  );
}

RecommendedSmall.propTypes = {
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      country: PropTypes.string,
      lowest_price: PropTypes.node,
      pricing_type: PropTypes.string,
      trip_type_description: PropTypes.string,
      is_featured: PropTypes.bool,
      // review_scores: PropTypes.arrayOf(PropTypes.number),
      image_url: PropTypes.string,
      distance: PropTypes.number,
    })
  ).isRequired,
};
